module.exports = __webpack_public_path__ + "static/img/contract_cz_card_temp.9fa42263.png";